import { AppId, BackofficeProvider } from '@revolut-internal/backoffice-provider'

import { MENU_ITEMS } from '../consts/navigation'
import { Route } from '../consts/routes'
import { Auth } from '../modules/auth/auth'
import { FCWithChildren } from '../types'

export const RootProvider: FCWithChildren = ({ children }) => {
  return (
    <BackofficeProvider
      appId={AppId.RealTimeMonitoring}
      menuItems={MENU_ITEMS}
      defaultRoute={Route.Ticket}
      auth={Auth}
    >
      {children}
    </BackofficeProvider>
  )
}
